import featureFlag from 'services/feature-flag/feature-flag';

export default {
  IsListAuditLogsShow: () =>
    featureFlag.getFlag('panel-list-audit-logs', false),

  IsAddEnvironmentShow: () =>
    featureFlag.getFlag('panel-add-environment', false),
  IsTargetAppVerisonShow: () =>
    featureFlag.getFlag('panel-target-app-version', false),
  IsConditionShow: () => true
};
